import { apiRequest } from "./apiClient";

function query({ bankAccountId, from, to }) {
  const params = new URLSearchParams({ bankAccountId, from, to });
  return params.toString();
}

export function listReconciliations(options) {
  return apiRequest(`/api/reconciliations?${query(options)}`);
}

export function saveReconciliation({ bankAccountId, date, actualBalance, notes }) {
  const params = new URLSearchParams({ bankAccountId, date });
  return apiRequest(`/api/reconciliations?${params.toString()}`, {
    method: "PUT",
    body: JSON.stringify({ actualBalance, notes }),
  });
}

export function closeReconciliation(id) {
  return apiRequest(`/api/reconciliations/${id}/close`, { method: "POST" });
}

export function reopenReconciliation(id, reason) {
  return apiRequest(
    `/api/reconciliations/${id}/reopen?reason=${encodeURIComponent(reason)}`,
    { method: "POST" }
  );
}
